<template>
  <a :href="link" v-bind="$attrs" class="text-lg">{{ linkText }}</a>
</template>

<script>
import { computed } from "vue";
import Detector from "detector-js";

export default {
  setup(props) {
    let address = encodeURIComponent(props.address);
    let userAgent = new Detector(window.userAgent);

    const link = computed(() => {
      if (userAgent.os.name == "macOS" || userAgent.os.name == "iOS") {
        return "http://maps.apple.com/?daddr=" + address;
      }

      return "https://maps.google.com/?q=" + address;
    });

    const linkText = computed(() => {
      if (userAgent.os.name == "macOS" || userAgent.os.name == "iOS") {
        return "Open in Apple Maps";
      }

      return "Open in Google Maps";
    });

    return {
      link,
      linkText
    };
  },

  props: {
    address: {
      required: true,
      type: String
    }
  }
};
</script>
